import { render, staticRenderFns } from "./EditOption.vue?vue&type=template&id=464c5352"
import script from "./EditOption.vue?vue&type=script&lang=js"
export * from "./EditOption.vue?vue&type=script&lang=js"
import style0 from "./EditOption.vue?vue&type=style&index=0&id=464c5352&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464c5352')) {
      api.createRecord('464c5352', component.options)
    } else {
      api.reload('464c5352', component.options)
    }
    module.hot.accept("./EditOption.vue?vue&type=template&id=464c5352", function () {
      api.rerender('464c5352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/price/EditOption.vue"
export default component.exports